import { cn } from "@lib/cn";
import { IconCheck, IconSelector } from "@tabler/icons-react";
import { useState } from "react";
import Popover from "../../ui/popover";

export type GradientType = "linear" | "radial";

export type TypeSelectorProps = {
	value: GradientType;
	onChange: (value: GradientType) => void;
};

const OPTIONS: Array<{ value: GradientType; label: string }> = [
	{ value: "linear", label: "Linear gradient" },
	{ value: "radial", label: "Radial gradient" },
];

/** Dropdown selecting linear vs radial gradient type. */
export const TypeSelector = ({ value, onChange }: TypeSelectorProps) => {
	const [open, setOpen] = useState(false);
	const activeLabel = OPTIONS.find((o) => o.value === value)?.label ?? value;

	return (
		<Popover open={open} onOpenChange={setOpen} placement="bottom-start">
			<Popover.Trigger>
				<button
					type="button"
					className={cn(
						"tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-overflow-hidden tw-rounded-lg tw-border-none tw-bg-white tw-px-3 tw-font-sans tw-text-sm tw-text-[#12033E] tw-shadow-sm tw-outline tw-outline-1 tw-outline-blue-base/5 tw-transition-colors hover:tw-outline-blue-200",
						open && "tw-outline-primary-300",
					)}
				>
					<span>{activeLabel}</span>
					<IconSelector
						className={cn(
							"tw-size-3.5 tw-text-blue-500",
							open && "tw-text-primary",
						)}
					/>
				</button>
			</Popover.Trigger>
			<Popover.Content className="tw-z-[999999] tw-min-w-[160px] tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-p-1 tw-shadow-popover">
				{OPTIONS.map((opt) => {
					const isActive = opt.value === value;
					return (
						<button
							key={opt.value}
							type="button"
							onClick={() => {
								onChange(opt.value);
								setOpen(false);
							}}
							className={cn(
								"tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-md tw-px-2 tw-py-1.5 tw-font-sans tw-text-[13px] tw-text-blue-base tw-outline-none tw-transition-colors hover:tw-bg-blue-50",
								isActive && "tw-bg-primary-50 tw-text-primary-base",
							)}
						>
							<span>{opt.label}</span>
							{isActive && (
								<IconCheck className="tw-size-3.5 tw-text-primary-base" />
							)}
						</button>
					);
				})}
			</Popover.Content>
		</Popover>
	);
};
